import { PATHS } from 'app/constants/api.constants'
import { SOUNDS_TYPE } from 'app/constants/sounds.constants'
import { getVideoSourcesList } from 'app/services/utils/video-formating.service'
import { GRADES } from 'app/types/grades.types'
import { SoundsItem } from 'app/types/sounds-reducer.types'

function getSoundAudioURL(soundurl: string, soundCategory: SOUNDS_TYPE) {
  if (soundCategory === SOUNDS_TYPE.SONIDOS) {
    return `${PATHS.CAMINOS_SOUNDS}/${soundurl}.mp3`
  }
  return `${PATHS.SOUNDS}/${soundurl}.mp3`
}

function getVideoSources(videourl: string, soundCategory: SOUNDS_TYPE) {
  if (soundCategory === SOUNDS_TYPE.SONIDOS) {
    return []
  }
  return getVideoSourcesList(`${PATHS.VIDEOS}/${videourl}`)
}

function getSongsSrc(songvideo: string) {
  return [
    {
      src: `${PATHS.SONGS}/videos/${songvideo}_1080.mp4`,
      type: 'video/mp4',
      size: 1080,
    },
    {
      src: `${PATHS.SONGS}/videos/${songvideo}_720.mp4`,
      type: 'video/mp4',
      size: 720,
    },
    {
      src: `${PATHS.SONGS}/videos/${songvideo}_360.mp4`,
      type: 'video/mp4',
      size: 360,
    },
  ]
}

function getSongPoster(songvideo: string) {
  return `${PATHS.SONGS}/videos/${songvideo}.jpg`
}

function getSoundVideoPosterURL(videourl: string) {
  return `${PATHS.VIDEOS}/${videourl}.jpg`
}

export function groupSoundItemsByUnit(
  list: SoundsItem[],
  currentGrade: GRADES
): { units: string[]; itemsByUnit: Record<string, SoundsItem[]> } {
  const itemsByUnitMap: Record<string, Map<string, SoundsItem>> = {}

  list.forEach((item) => {
    let { name: itemKey } = item
    const { effect } = item
    if (effect) itemKey = `${itemKey}_${effect}`
    item.grades.forEach((grade) => {
      if (grade.gradesample === currentGrade) {
        const { unit } = grade
        if (itemsByUnitMap[unit]) {
          itemsByUnitMap[unit].set(itemKey, item)
        } else {
          itemsByUnitMap[unit] = new Map([[itemKey, item]])
        }
      }
    })
  })

  const units = Object.keys(itemsByUnitMap)

  const itemsByUnit: Record<string, SoundsItem[]> = {}
  // transfrom units from map to array
  units.forEach((key) => {
    itemsByUnit[key] = [...itemsByUnitMap[key].values()]
  })

  return {
    units,
    itemsByUnit,
  }
}

export default {
  getSoundAudioURL,
  getVideoSources,
  getSoundVideoPosterURL,
  getSongsSrc,
  getSongPoster,
}
